(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("async-tick", [], factory);
	else if(typeof exports === 'object')
		exports["async-tick"] = factory();
	else
		root["async-tick"] = factory();
})(self, () => {
return 